import { render, staticRenderFns } from "./HistoricoEntrada.vue?vue&type=template&id=43f48dbe"
import script from "./HistoricoEntrada.vue?vue&type=script&lang=js"
export * from "./HistoricoEntrada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports